var map = {
	"./about-app/game.svg": 583,
	"./about-app/learn.svg": 584,
	"./about-app/scan.svg": 585,
	"./about-app/tips.svg": 586,
	"./arrow.svg": 547,
	"./bt-round-active.svg": 555,
	"./bt-round-hover.svg": 556,
	"./bt-round.svg": 557,
	"./check-box-checked.svg": 544,
	"./close.svg": 638,
	"./contract.svg": 639,
	"./done.svg": 558,
	"./download.svg": 640,
	"./email.svg": 641,
	"./feedback.svg": 302,
	"./game.svg": 642,
	"./go.svg": 643,
	"./menu.svg": 644,
	"./next.svg": 645,
	"./polygon_arrow.svg": 550,
	"./search.svg": 646,
	"./sign.svg": 303,
	"./vertical_dots.svg": 543,
	"./words-containing-outlined.svg": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;